import './styles/styles.scss';

import { ConfigProvider } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import Startup from './features/startup/Startup';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#45606B',
          fontFamily: 'PT Sans, sans-serif',
        },
      }}
    >
      <Startup />
    </ConfigProvider>
  </Provider>,
);
